import styled from "styled-components";
import { getTrackBackground } from "react-range";
// components
import { Layer } from "./layer.styles";
export const Thumb = styled.div `
  box-shadow: 0 1px 2px
    rgba(${({ theme }) => theme.colors.transparentBlack}, 0.36);
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 1rem;
  top: -1px;
  background: ${({ theme, disabled }) => disabled ? theme.colors.grey07 : theme.colors.white};

  &:before {
    content: "";
    position: absolute;
    border: 1px solid transparent;
    border-radius: 50%;
    width: 2.375rem;
    height: 2.375rem;
    top: -0.5rem;
    left: -0.5rem;
  }

  &:focus {
    outline: none;

    &:before {
      ${({ focused, theme }) => focused
    ? `border: 1px solid ${theme.colors.primaryLight};
          box-shadow: 0px 0px 0px 1px ${theme.colors.primaryLight};`
    : ""}
    }
  }

  &:hover {
    ${({ disabled, theme }) => !disabled
    ? `box-shadow: 0 1px 2px rgba(${theme.colors.transparentBlack}, 0.36),
      0 0 0 0.5rem rgba(${theme.colors.transparentBlack}, 0.08);`
    : ""};

    ${Layer} {
      display: ${({ disabled }) => (!disabled ? "flex;" : "none;")};
    }
  }

  &:active {
    ${({ theme, disabled }) => !disabled
    ? `box-shadow: 0 1px 2px rgba(${theme.colors.transparentBlack}, 0.36),
      0 0 0 0.5rem rgba(${theme.colors.transparentBlack}, 0.26);`
    : ""};
  }
`;
export const TrackWrapper = styled.div `
  width: 100%;
`;
export const Track = styled.div `
  background: ${({ values, theme, min, max, multiple, disabled }) => {
    let colors = [
        theme.colors.primaryLight,
        `rgba(${theme.colors.transparentBlack},0.16)`,
    ];
    if (multiple && !disabled) {
        colors = [
            `rgba(${theme.colors.transparentBlack},0.16)`,
            theme.colors.primaryLight,
            `rgba(${theme.colors.transparentBlack},0.16)`,
        ];
    }
    if (!multiple && disabled) {
        colors = [
            `rgba(${theme.colors.transparentBlack},0.08)`,
            `rgba(${theme.colors.transparentBlack},0.04)`,
        ];
    }
    if (multiple && disabled) {
        colors = [
            `rgba(${theme.colors.transparentBlack},0.04)`,
            `rgba(${theme.colors.transparentBlack},0.08)`,
            `rgba(${theme.colors.transparentBlack},0.04)`,
        ];
    }
    return getTrackBackground({
        values,
        colors,
        min,
        max,
    });
}};
  border-radius: 1rem;
  height: 0.313rem;
  align-self: center;
`;
